export const ACTIVE_APPLICATION_GET_STUDENTS =
  'ACTIVE_APPLICATION_GET_STUDENTS';
export const ACTIVE_APPLICATION_GET_STUDENTS_ERROR =
  'ACTIVE_APPLICATION_GET_STUDENTS_ERROR';
export const ACTIVE_APPLICATION_CLEAR_ERROR = 'ACTIVE_APPLICATION_CLEAR_ERROR';
export const ACTIVE_APPLICATION_CLEAR_STUDENTS_ERROR =
  'ACTIVE_APPLICATION_CLEAR_STUDENTS_ERROR';
export const ACTIVE_APPLICATION_SAVE_FILTERS =
  'ACTIVE_APPLICATION_SAVE_FILTERS';
export const MANAGE_APPLICATION_LOADING = 'MANAGE_APPLICATION_LOADING';
export const MANAGE_APPLICATION_ACTIVE_APPLICATIONS_LOADING =
  'MANAGE_APPLICATION_ACTIVE_APPLICATIONS_LOADING';
export const MANAGE_APPLICATION_AVAILABLE_TO_DECLINE =
  'MANAGE_APPLICATION_AVAILABLE_TO_DECLINE';
export const MANAGE_APPLICATION_REPRINTED_SUCCESSFULLY =
  'MANAGE_APPLICATION_REPRINTED_SUCCESSFULLY';
export const ACTIVE_APPLICATION_RESET_REPRINT_FLAG =
  'ACTIVE_APPLICATION_RESET_REPRINT_FLAG';
export const MANAGE_APPLICATION_SET_AUTO_POPULATE_STUDENT_DATA =
  'MANAGE_APPLICATION_SET_AUTO_POPULATE_STUDENT_DATA';



// WEBPACK FOOTER //
// ./src/pages/manageapplication/state/manageapplication/types.js